import { ReactNode } from 'react';

import { Tooltip } from '@iwoca/orion';
import { Cvv } from 'frames-react';
import { FormattedMessage, useIntl } from 'react-intl';

import { DebitCardFieldWrapper } from '../../DebitCardFieldWrapper';

export const CVVField = ({
    label: labelOverride
}: { label?: ReactNode } = {}) => {
    const intl = useIntl();

    const defaultLabel = (
        <span className="inline-flex items-center gap-m font-bold">
            <FormattedMessage id="_.link_debit_card.cvv" defaultMessage="CVC" />
            <Tooltip
                dataTestId="cvvHelpTooltip"
                placement="top"
                content={intl.formatMessage({
                    id: '_.link_debit_card.cvv_number_tooltip',
                    defaultMessage:
                        'The 3 digit number on the back of your card'
                })}
            />
        </span>
    );

    return (
        <DebitCardFieldWrapper
            label={labelOverride ?? defaultLabel}
            htmlFor="cvv"
        >
            <Cvv className="CheckoutElement" data-testid="checkout-cvv" />
        </DebitCardFieldWrapper>
    );
};
